import { events, CoreEvents } from 'coreEventsOLD';
import DiscountsApi from '@services/DiscountsApi';
import {
  fetchShouldFireHeaderEventablePageLoadEventBegin,
  fetchShouldFireHeaderEventablePageLoadEventFailure,
  fetchShouldFireHeaderEventablePageLoadEventSuccess,
  fetchTradeInProgress,
  fetchTradeSuccess,
  getDiscountsError,
  getDiscountsSuccess,
  requestProfile,
  requestProfileError,
  requestProfileSuccess
} from '@Header/ducks/actions';
import HeaderApi from '@services/HeaderApi';
import qs from 'qs';
import { removeQueryParam } from '@utilities';
import { setSelectedTab } from '@Header/Modals/AccountModal/ducks/actions';
import { ACCOUNT_MODAL_TABS } from '@constants';
import Profile from '@Provider/Profile';
import { getPurchaseDetailsLoading } from '@Header/Account/ducks/actions';
import { CLOSE_CURRENT_MODAL, HANDLE_PROMOTIONS, CLOSE_CREATE_ACCOUNT } from '@Header/Modals/ducks/types';
import { shouldDisplayPromotion, shouldDisplayPromotionModal } from '@Header/ducks/utils';
import { SET_ENABLED_PROMOTIONS } from './types';

export const getDiscounts = stateAbbreviation => dispatch => {
  // note(oscar): this state is never reset away from loading
  dispatch(getPurchaseDetailsLoading());
  return DiscountsApi.fetchDiscounts(stateAbbreviation)
    .then(response => {
      dispatch(getDiscountsSuccess(response));
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error('[getDiscounts::error]', error);
      dispatch(getDiscountsError(error));
    });
};

export const fetchTrade = () => dispatch =>
  new Promise(resolve => {
    dispatch(fetchTradeInProgress(true));
    resolve();
  })
    .then(() => HeaderApi.fetchTrade())
    .then(trade => {
      dispatch(fetchTradeSuccess(trade));
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error);
    })
    .then(() => {
      dispatch(fetchTradeInProgress(false));
    });

export const closeCurrentModal = () => dispatch => {
  CoreEvents.emit(events.accountModal.close);

  const { openAccountModal } = qs.parse(window.location.search, { ignoreQueryPrefix: true });

  if (openAccountModal) {
    removeQueryParam('openAccountModal');
    dispatch({ type: CLOSE_CREATE_ACCOUNT });
  }

  dispatch(setSelectedTab(ACCOUNT_MODAL_TABS.signIn));
  dispatch({
    type: CLOSE_CURRENT_MODAL
  });
};

// note(oscar): only gets used on account creation
export const getUserProfile = () => dispatch => {
  dispatch(requestProfile());
  return Profile.getProfileFromServer()
    .then(profile => dispatch(setUserProfile(profile)))
    .catch(error => dispatch(requestProfileError(error)));
};

export const setUserProfile = profile => dispatch => {
  dispatch(requestProfileSuccess(profile));
};

// todo(oscar): this could probably be moved to modals as well?
export const handlePromotions = (headerBannersAndModals, geolocation) => dispatch => {
  const enabledPromotions = headerBannersAndModals?.promotions
    .filter(promo => shouldDisplayPromotion(promo, geolocation)) ?? [];
  const promotionModals = enabledPromotions
    .filter(shouldDisplayPromotionModal)
    .map(({ name }) => name);

  // todo(oscar): probably need to make into an action
  dispatch({
    type: SET_ENABLED_PROMOTIONS,
    payload: enabledPromotions
  });
  dispatch({
    type: HANDLE_PROMOTIONS,
    payload: promotionModals
  });
};

export const getShouldFireHeaderEventablePageLoadEvent = () => dispatch => {
  dispatch(fetchShouldFireHeaderEventablePageLoadEventBegin());
  return HeaderApi.fetchAppSettings(['ShouldFireHeaderEventablePageLoadEvent'])
    .then(response => {
      dispatch(fetchShouldFireHeaderEventablePageLoadEventSuccess(response.ShouldFireHeaderEventablePageLoadEvent));
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error);
      dispatch(fetchShouldFireHeaderEventablePageLoadEventFailure(error));
    });
};
